module.exports = __webpack_public_path__ + "static/media/1Asset-9Human.e9703987.png";